<main class="marketplace-page py-5">
  <div class="container marketplace-container">
    <div class="row justify-content-center">
      <div class="col-md-9 col-lg-7">
        <section class="marketplace-card card border-0 shadow-sm">
          <div class="card-body p-4 p-md-5">
            <p class="marketplace-eyebrow text-uppercase fw-bold mb-2">Microsoft Marketplace</p>
            <h1 class="h2 fw-bold mb-4">Marketplace activation error</h1>

            <div class="alert alert-danger border-0" role="alert">
              {{ error_message }}
            </div>

            <div class="d-grid d-sm-flex justify-content-sm-end mt-4">
              <button type="button" class="btn marketplace-primary-btn px-4" @click="go_to_login">
                Back to login
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</main>
